import styled from "styled-components";

export const Container = styled.section`
  margin: 50px 0;

  .p_title {
    width: 100%;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    & div {
      margin-bottom: 0px !important;
    }
    @media screen and (max-width: 1199px) {
      display: none;
    }
  }

  .m_title {
    display: none;
    @media screen and (max-width: 1199px) {
      display: flex;
    }
  }
`;

/* ✅ 모바일에서 1열로 자동 전환되는 공통 필터 행 */
export const FilterRow = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  border-bottom: 1px solid #e5e7eb;

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* 모바일 1열 */
  }

  .label {
    background: #10b981;
    color: #fff;
    padding: 14px 16px;
    font-weight: 700;
  }
  .content {
    padding: 10px 16px;
  }
`;

export const ListViewTypeWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const ListViewSelectBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 10px;
    border: 1px solid #ececec;
    cursor: pointer;
  }

  .selected {
    background-color: #3bb77e;
    color: white;
    border: 1px solid #3bb77e;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .cnt {
    font-size: 16px;
  }
  .filter {
    width: fit-content;
  }

  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    .cnt {
      width: 100%;
      margin-bottom: 10px;
    }
    .filter {
      width: 100%;
    }
  }
  @media (max-width: 767px) {
    & span {
      font-size: 14px;
    }
  }
`;

export const ListWraper = styled.div`
  margin-bottom: 50px;
`;

export const CategoryTitle = styled.h4`
  width: 100%;
  border-bottom: 1px solid #ececec;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;

export const ProductsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 20px;
  margin-bottom: 20px;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }

`;

export const ProductsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ProductsSignWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  word-break: keep-all;
  margin-top: 50px;
  margin-bottom: 30px;
  & h4 {
    margin-bottom: 20px;
    text-align: center;
  }
  @media (max-width: 991px) {
    & h4 {
      font-size: 18px;
    }
    & a {
      font-size: 14px;
    }
  }
  @media (max-width: 767px) {
    & h4 {
      font-size: 16px;
    }
    & a {
      padding: 5px 20px;
      font-size: 12px;
    }
  }
`;

/* table type list */
export const TableTypeWrapper = styled.div`
  display: flex;
`;

export const Table = styled.table`
  color: #253d4e;
  .header {
    background-color: #f9f6f6ba;
  }
  & tr {
    text-align: center;
    :hover {
      background-color: #f9f6f6ba;
    }
  }

  & th {
    padding: 5px;
    font-size: 14px;
    word-break: keep-all;
  }

  & td {
    padding: 10px;
  }

  & a {
    color: #253d4e;
  }

  .img {
    width: 10%;
    padding: 5px;
    & a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .name {
    width: 15%;
    & a {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      word-break: keep-all;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .price {
    color: #dc3545;
  }

  .btnWrapper {
    width: 15%;
  }

  @media (max-width: 991px) {
    & td {
      padding: 5px;
    }
    .name { }
    .golgi {
      width: 7%;
    }
    .feature {
      width: 15%;
    }
    .sizes {
      width: 10%;
    }
    .onePrice {
      width: 10%;
    }
    .quantity {
      width: 10%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 767px) {
    & th {
      font-size: 12px;
    }
    & td {
      font-size: 12px;
    }
    .img {
      display: none;
    }
    .golgi {
      width: 7%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 575px) {
    & th {
      font-size: 10px;
    }
    & td {
      font-size: 10px;
      padding: 5px;
    }
    .name {
      width: 25%;
    }
    .sizes {
      display: none;
    }
    .strength {
      width: 10%;
    }
    .feature {
      width: 10%;
    }
    .golgi { }
    .onePrice { }
    .quantity { }
    .price { }
  }
  @media (max-width: 460px) {
    .quantity {
      display: none;
    }
    .onePrice {
      display: none;
    }
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  word-break: keep-all;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 1.5;
  }
  @media (max-width: 767px) {
    font-size: 10px;
  }
  @media (max-width: 575px) {
    font-size: 8px;
  }
`;

export const CheckoutBtn = styled.button`
  background-color: #fd7e14;
  color: #fff;
  border: 1px solid #fd7e14;
  margin-bottom: 2px;
  :hover {
    opacity: 0.8;
  }
`;

export const CartBtn = styled.button`
  background-color: ${(props) => (props.inCart ? "#3bb77e" : "#fff")};
  color: ${(props) => (props.inCart ? "#fff" : "#3bb77e")};
  border: 1px solid #3bb77e;
  :hover {
    opacity: 0.8;
  }
`;

export const PriceBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;

  & > div {
    & span {
      text-decoration: line-through;
      color: #6c757d;
      opacity: 0.5;
    }
  }
`;

export const SearchedCommunity = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
  /* ✅ 아주 작은 폭에서 1열 */
  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const CommunityBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ececec;
  border-radius: 10px;
  padding-bottom: 20px;
  overflow: hidden;
  transition: 0.2s;

  .thumbnail {
    width: 100%;
    margin-bottom: 10px;
    & img {
      display: block;          /* ✅ 모바일 이미지 간헐적 공백 방지 */
      width: 100%;             /* ✅ 가로 100% */
      height: auto;
      object-fit: cover;
    }
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;

    & h5 {
      font-size: 20px;
      word-break: keep-all;
      overflow-wrap: anywhere; /* ✅ 길게 붙은 단어도 줄바꿈 */
      margin-bottom: 10px;
      padding: 0px 10px;
      transition: 0.2s;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;     /* ✅ 'wrap' → 'normal' 로 수정 */
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      align-items: center;
    }

    @media (max-width: 991px) {
      & h5 { font-size: 16px; }
      height: 40px;
    }
    @media (max-width: 460px) {
      & h5 { font-size: 14px; }
      height: 34px;
    }
  }

  .sub_title {
    color: #58585f;
    padding: 0px 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 991px) {
      font-size: 16px;
    }
    @media (max-width: 460px) {
      font-size: 12px;
    }
  }

  :hover {
    border-color: #3bb77e;
    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);

    .title { color: #3bb77e; }
  }
`;

export const MoreBtn = styled.div`
  width: fit-content;
  cursor: pointer;
  background-color: #3bb77e;
  padding: 10px 20px;
  border-radius: 10px;
  margin: auto;
  color: #fff;

  /* ✅ 모바일에서는 풀폭으로 탭 히트박스 확대 */
  @media (max-width: 520px) {
    width: 100%;
    text-align: center;
  }
`;
